export default "__VITE_ASSET__Bm3mS7Vi__"